import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chart-line', 'ChartLine', [["path",{"d":"M4 19l16 0"}],["path",{"d":"M4 15l4 -6l4 2l4 -5l4 4"}]]);